module.exports = __webpack_public_path__ + "img/2002.09d5983d.jpg";